<div class="front-modal">
  <div class="action-modal">
      <img class="mr-3" appImageSelector alt="mt-image" imageType="icon" imageKey="download-white" (click)="downloadImage()">
      <img appImageSelector alt="mt-image" imageType="icon" imageKey="close-white" (click)="activeModal.close('Close click')">
  </div>

  <div class="header">
      <div class="title">
          {{ title }}
      </div>
  </div>

  <div class="body d-flex flex-row">
    <img class="img" alt="mt-image" *ngIf="imageUrl" [src]="imageUrl"/>
    <div class="description d-flex flex-column justify-content-end">
      <div>{{ date }}</div>
      <div class="detail">{{ detail }}</div>
      <div class="align-self-end">{{ userFullName }}</div>
    </div>
  </div>
</div>
